import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import { alerts } from "../util/alert_error_utils"
import { makeToast } from "../util/toast_util"
import { appStrings } from "../common/strings/app_strings"
import { Link } from "react-router-dom"
import { isLoggedIn } from "../util/jwt_utils"

const { email, password } = appStrings.onboarding
const { forgotPassword, signIn } = appStrings.signIn
export class SignIn extends React.Component {
    constructor(props) {
        super(props)
        this.handleLogin = this.handleLogin.bind(this)
        this.fieldSetter = this.fieldSetter.bind(this)
        // this.handleOauth = this.handleOauth.bind(this)

        this.state = {
            email: "",
            password: "",
            showSignIn: false,
        }
    }

    // componentWillMount() {
    //     this.props.startGoogleAuth().then( resp => {
    //         this.setState({
    //             google: resp.iframeSrc,
    //         })
    //     })
    // }

    fieldSetter(fieldName) {
        return e => this.setState({ [fieldName]: e.target.value })
    }

    componentDidMount() {
        // only show content if not logged in
        if (!isLoggedIn()) {
            this.setState({ showSignIn: true })
        }
    }

    handleLogin(event) {
        event.preventDefault()
        const { email, password } = this.state
        const validationError = alerts[this.validateFields(email, password)]

        if (validationError) {
            // toast
            const msg = validationError.msg
            const ind = "danger"
            makeToast(msg, ind)
            return
        } else {
            const accountMeta = {
                email,
                password,
            }
            this.props.signIn(accountMeta)
        }
    }

    // handleOauth() {
    //     // define params for popup window
    //     const w = 650
    //     const h = 600
    //     const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX
    //     const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY
    //     const width = window.innerWidth ? 
    //         window.innerWidth 
    //         :
    //         document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    //     const height = window.innerHeight ? 
    //         window.innerHeight 
    //         : 
    //         document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

    //     const left = ((width / 2) - (w / 2)) + dualScreenLeft
    //     const top = ((height / 2) - (h / 2)) + dualScreenTop
        
    //     // create popup window
    //     const child = window.open("", null, `
    //         height=${h},
    //         width=${w},
    //         status=yes,
    //         toolbar=no,
    //         menubar=no,
    //         location=no,
    //         titlebar=no,
    //         left=${left},
    //         top=${top}
    //     `)
        
    //     this.props.startGoogleAuth(child)
    // }

    validateFields(email, password) {
        if (email.length === 0) {
            return "emailRequired"
        }
        if (password.length === 0) {
            return "passwordRequired"
        }
        return null
    }

    render() {
        return (
            this.state.showSignIn && (
                <div className="container sign-in">
                    <form id="signin-form">
                        <div className="row">
                            <div className="col-md-12">
                                <h4 className="center">Welcome back</h4>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 form-group">
                                <input
                                    autoFocus
                                    type="email"
                                    onChange={this.fieldSetter("email")}
                                    value={this.state.email}
                                    id="signin-email"
                                    className="form-control"
                                    placeholder={email}
                                    tabIndex="1"
                                    required="true"
                                />
                            </div>
                            <div className="col-md-12 form-group">
                                <input
                                    type="password"
                                    onChange={this.fieldSetter("password")}
                                    value={this.state.password}
                                    id="signin-password"
                                    className="form-control"
                                    placeholder={password}
                                    tabIndex="2"
                                    style={{ margin: 0 }}
                                    required="true"
                                />
                            </div>
                        </div>
                        <div className="form-actions">
                            <input
                                type="submit"
                                className="btn btn-primary btn-block btn-custom"
                                tabIndex="3"
                                value={signIn}
                                onClick={this.handleLogin}
                            />
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-12 link-container">
                            <Link
                                id="forgot-password-link"
                                to="/forgotPassword"
                                className="forgot-password"
                                tabIndex="7"
                            >
                                {forgotPassword}
                            </Link>
                        </div>
                    </div>
                    <Link id="sign-up-link" to="/signUp">
                        <button className="btn btn-primary sign-in-button">
                            Sign up
                        </button>
                    </Link>
                </div>
            )
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(SignIn)



// WEBPACK FOOTER //
// ./src/pages/sign_in.jsx